module.exports = __webpack_public_path__ + "img/vip_level_4.5b5abe39.png";